import { createStructuredSelector } from 'reselect';

export const getApp = (state) => state.app;

export const getAllChannelsUrl = (state) => state.app.allChannelsUrl;

export const getShowAllChannelsButton = (state) => state.app.showAllChannelsButton;

export default createStructuredSelector({
  getAllChannelsUrl,
  getShowAllChannelsButton,
});
